export const DATASETS_RESULTS_ANALYSIS_NO_DATA_MESSAGE_MAPPING = {
  "no-data": {
    title: "No Results",
    description: ""
  },
  "no-result": {
    title: "No Results Found",
    description:
      "Sorry, we couldn't find any matches from your keyword. Try using different or more general terms"
  }
};
